import { firebase } from "../../firebase";
import db from "../../firebase";
import { collection, doc, setDoc, getDoc } from "firebase/firestore";

export class modelAnalytics {

async  Crear(data) {
    /* console.log('crear -->       ',data); */
    try {
         

        const pedidoDocRef = doc(
            db,
            "analytics",
            data.id,
            "Pedidos",
            data.y,
            data.m,
            "data"
        );
        const snap = await getDoc(pedidoDocRef);
        await setDoc(pedidoDocRef, { coleccion: data.data });

        return true;
    }
    catch (error) {
        console.log(error);
        
        return false;
    }
}

async eliminar(data) {
  
/*     try {
        
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
        }

        const pedidoDocRef = doc(
            db,
            "analytics",
            data.id,
            "Pedidos",
            data.year,
            data.mes,
            "data"
        );

        const snap = await getDoc(pedidoDocRef);
        if (snap.exists()) console.log('Documento', snap.data());

        await setDoc(pedidoDocRef, { coleccion: data.data });
    }
    catch (error) {
        console.log(error);

    } */
}

async obtenerDatos(data) {
    try {
        
        /* console.log('obtenerDatos-->',data); */
        
        const pedidoDocRef = doc(
            db,
            "analytics",
            data.id,
            "Pedidos",
            data.y,
            data.m,
            "data"
        );

        const snap = await getDoc(pedidoDocRef);
        if (snap.exists()) {
            
            return { status: true, data: snap.data() };
        }
        return { status: false }

    }
    catch (error) {
       
        return { status: false }
    }
}

timestampToDate(timestamp) {
    
    
    return new Date(timestamp.seconds * 1000);
}

}
